import styled from 'styled-components';

export const ReportingConnectPage = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ReportingConnectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  border-radius: 12px;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  border: 1px solid ${(props) => props.theme.newPalette.neutral.N400};
  padding: 30px 20px;
  max-width: 450px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
    width: 100%;
    border: none;
  }
`;

export const ReportingConnectHeading = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLarge};
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ReportingConnectLogo = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0 20px 0;
`;

export const ReportingConnectListHeading = styled.div`
  padding: 20px 0 10px 0;
  ${(props) => props.theme.newTypography.textStyleBody};
  font-weight: 600;
`;

export const ReportingConnectListContainer = styled.div`
  padding-bottom: 20px;
`;

export const ReportingConnectListItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N400};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InfoIconContainer = styled.div`
  margin-left: 10px;
`;

export const ReportingConnectButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
`;

export const ReportingConnectDisclaimer = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.newPalette.neutral.N500};
  padding-top: 20px;
`;
